import { Fragment, useState, useEffect, useRef } from "react";

import MenuItem from "@mui/material/MenuItem";

import MySelectField from "components/Inputs/MySelectField";
import { getDrivers } from "~/services/http/drivers";

const DriverSelect = (props) => {
  const { value, updateValues, companies, myUser } = props;
  const updateValuesRef = useRef(updateValues);
  updateValuesRef.current = updateValues;

  const [drivers, setDrivers] = useState();

  useEffect(() => {
    const request = {
      params: {
        drivers: true,
        company: companies?.data?.me?.id,
      },
    };
    getDrivers(request).then((response) => {
      if (myUser?.status < 100) {
        setDrivers([{ ...myUser }]);

        updateValuesRef.current({ ["driver"]: myUser?.user_role_id });
      } else {
        setDrivers([{ user_role_id: -1, first_name: "Kaikki" }, ...response]);
      }
    });
  }, [companies?.data?.me?.id, myUser]);

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      <MySelectField
        id="select_driver"
        name="driver"
        value={value ? value : -1}
        onChange={handleSelectChange}
      >
        {drivers
          ? drivers.map((driver) => (
              <MenuItem key={driver.user_role_id} value={driver.user_role_id}>
                {driver.first_name} {driver.last_name}
              </MenuItem>
            ))
          : null}
      </MySelectField>
    </Fragment>
  );
};

export default DriverSelect;
